import { type FC } from "react";

import { ConfirmDialog } from "@styled/confirm_dialog";
import { ErrorLine } from "@styled/error_line";

import { useDraftingSectionsOf } from "./use_drafting_sections";

// Asks before drafting a section he edited again: Replace drops his edits and
// drafts it; Keep mine leaves his text and doesn't ask the chat.
export const DraftingSectionReplace: FC<{
  section: { id: string; name: string };
  onReplace(): void;
  onClose(): void;
}> = ({ section, onReplace, onClose }) => {
  const drafting = useDraftingSectionsOf();
  return (
    <ConfirmDialog
      title="Replace your edits?"
      action="Replace"
      cancel="Keep mine"
      loading={drafting.clearing}
      onClose={onClose}
      onConfirm={() => {
        void drafting.clearEdits(section.id).then((cleared) => {
          if (!cleared) return;
          onClose();
          onReplace();
        });
      }}
    >
      Drafting {section.name} again replaces the text you edited in your report.
      {drafting.clearError && <ErrorLine>{drafting.clearError}</ErrorLine>}
    </ConfirmDialog>
  );
};
